module.exports = __webpack_public_path__ + "static/img/hr-banner.efb2bcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/hr-banner.png
// module id = mbhx
// module chunks = 2